/* screens/demo/demoAccess.jsx — мост «переиспользуемый экран → форма заявки» демо-стенда.
 *
 * НЕ через React-контекст: экраны аналитики (ReportHeader/IikoStaffReport) попадают
 * в отдельный ленивый чанк, а провайдер — в чанк демо-страницы; идентичность контекста
 * между чанками не гарантирована (useContext вернул бы дефолт). Поэтому:
 *   • isDemoRoute() — детект демо по текущему пути (единый источник, как в api/client.js);
 *   • requestDemoAccess() — window-событие (истинный синглтон, работает через любые чанки);
 *   • useDemoLeadListener() — подписка BusinessDemo, открывающая форму.
 * Вне демо isDemoRoute()===false → реальные экраны ведут себя обычным образом. */
import React from 'react';
import { isDemoPath } from '../../lib/api/client.js';

const DEMO_EVENT = 'restorium:demo-lead';

// Одна реализация проверки пути на весь фронт: экраны и сетевой слой (переписывание
// запросов, область хранения) обязаны считать демо-стендом одно и то же.
export function isDemoRoute() {
  return isDemoPath();
}

// Открыть форму заявки вместо AI-действия. reason — метка триггера ('ai' и т.п.).
export function requestDemoAccess(reason = 'ai') {
  if (typeof window === 'undefined') return false;
  window.dispatchEvent(new CustomEvent(DEMO_EVENT, { detail: { reason } }));
  return true;
}

// BusinessDemo подписывается на запросы формы из переиспользуемых экранов.
export function useDemoLeadListener(onRequest) {
  React.useEffect(() => {
    const handler = (e) => onRequest((e.detail && e.detail.reason) || 'ai');
    window.addEventListener(DEMO_EVENT, handler);
    return () => window.removeEventListener(DEMO_EVENT, handler);
  }, [onRequest]);
}
